import { Routes } from '@angular/router';

export const routes: Routes = [
  { path: 'demo', loadComponent: () => import('./pages/demo/demo.component').then((m) => m.DemoComponent) },
  { path: 'buttons', loadComponent: () => import('./pages/buttons/buttons.component').then((m) => m.ButtonsComponent) },
  { path: 'colors', loadComponent: () => import('./pages/colors/colors.component').then((m) => m.ColorsComponent) },
  {
    path: 'typography',
    loadComponent: () => import('./pages/typography/typography.component').then((m) => m.Typography),
  },
  { path: '', redirectTo: 'demo', pathMatch: 'full' },
];
